export default {
  tab: {
    prospect: 'Các Thị Trường',
    index: 'Chỉ số',
    valuation: 'Định Giá',
    liquidity: 'Thanh Khoản',
    marketAnomaly: 'Biến Động',
  },

  indexSummary: {
    totalVolume: 'Tổng KL: ',
    totalValue: 'Tổng GT: ',
    bnVnd: 'Tỷ VND',
  },
};
